import { BPanel, Breadcrumb } from '@sketchpixy/rubix';
import { Link } from 'react-router';
import React from 'react';

import { AlertSchema, Alerts } from '../../collections/alerts/alerts';
import MgfForm from '../common/mgfForm';

export default class AlertEditPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		if (this.props.params.id)
			this.place = Alerts.findOne({_id: this.props.params.id});
		else
			this.context.router.push('/alerts');
	}

	handleSubmit(doc) {
		this.context.router.push('/alerts');
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/alerts">Alertes</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Modifier une alerte
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Modifier une alerte">
					<MgfForm schema={AlertSchema} collection={Alerts} model={this.place} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>
			</div>
		);
	}
}

AlertEditPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/alerts/AlertEdit.page.js
 **/